import React from "react";
import { UserMinus, UserPlus } from "lucide-react";
import { ReserveFormAdminReservation } from "@/features/reserve/components/Reserve/views/ReserveFormAdminReservation";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";

const classes = {
  Wrapper: "flex flex-col gap-2 text-left",
  Toggle:
    "flex items-center gap-2 self-start text-neutral-900 text-sm hover:text-primary",
  Icon: "size-4"
};

export const ReserveFormOtherUserReservation: React.FC = () => {
  const { allowOthers, setEnableAdminReservation, enableAdminReservation } =
    useReserveForm();
  if (!allowOthers) return null;

  return (
    <div className={classes.Wrapper}>
      <button
        type="button"
        aria-expanded={enableAdminReservation}
        onClick={(ev) => {
          ev.preventDefault();
          setEnableAdminReservation((x) => !x);
        }}
        className={classes.Toggle}
      >
        {enableAdminReservation ? (
          <UserMinus className={classes.Icon} />
        ) : (
          <UserPlus className={classes.Icon} />
        )}
        Create Reservation for Another User
      </button>
      <ReserveFormAdminReservation />
    </div>
  );
};
